import { React, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAdvisory, addAdvisory, selectAdvisory } from "./advisorySlice";
import CardAdvisory from "../../components/cardAdvisory/CardAdvisory";
import style from "./style.module.css";

const Advisory = () => {
  const advisoryState = useSelector(selectAdvisory); //get the advisory slice state using useSelector
  const dispatch = useDispatch();

  //executes on first render to load data
  const onFirstRender = () => {
    dispatch(loadAdvisory());
  };

  useEffect(onFirstRender, []); //renders on first time page load.

  return (
    <>
      {/* Page-Banner section starts...*/}
      <section>
        <div className="pageBanner">
          <div className="bannerContent">
            <h1 className="page-banner-title">Advisory Board</h1>
          </div>
        </div>
      </section>
      {/* Page-Banner section ends...*/}

      <section className={style.directorsSection}>
        <CardAdvisory advisoryState={advisoryState} />
      </section>
    </>
  );
};

export default Advisory;
